import React from 'react';
import { useParams } from 'react-router-dom';
import ScheduleInfo from '../components/ScheduleInfo';
import { useSchedule } from '../hooks/useSchedule';

const ScheduleDetail = () => {
  const { groupId, scheduleId } = useParams();
  const { schedule, participate, cancel, remove } = useSchedule(
    groupId!,
    scheduleId!
  );
  if (!schedule) {
    return <div>null</div>;
  }

  return (
    <ScheduleInfo
      groupId={groupId!}
      schedule={schedule}
      participate={participate}
      cancel={cancel}
      remove={remove}
    />
  );
};

export default ScheduleDetail;
